/**
 * @param {String} primarySrc
 * @param {String} secondarySrc
 * */
export const getImageUrl = (primarySrc, secondarySrc) => primarySrc || secondarySrc;
